import { mutatorAction } from 'satcheljs';
import { getCopilotChatDrawerState } from '../store/store';

export const closeBizChatInReadingPaneAndSetWidthMutator: (
    targetWindow: Window,
    newWidth: number
) => void = mutatorAction(
    'closeBizChatInReadingPaneAndSetWidthMutator',
    (targetWindow: Window, newWidth: number) => {
        const state = getCopilotChatDrawerState(targetWindow);
        if (!state) {
            return;
        }
        state.showInReadingPane = false;
        state.userPreferredWidth = newWidth;
    }
);
